import { useAFormHandler } from 'analytics/hooks'
import { useFormik } from 'formik'
import { endpoints } from 'modules/endpoints'
import { RequestError } from 'modules/errors'
import { apiClient } from 'modules/utils/httpClient'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { ResponsiveModal } from 'views/components/ResponsiveModal/ResponsiveModal'
import { ElevatorCommonFields, ElevatorFormFields } from './ElevatorCommonFields'
import { removePropertyNamePrefix } from 'modules/utils/helpers'

type Props = {
  onClose: () => void
  onSuccess: () => void
}

export const AddElevatorModal: FC<Props> = ({ onClose, onSuccess }) => {
  const { t } = useTranslation('warehouses')
  const { formProgress, formHandler } = useAFormHandler()

  const formik = useFormik<ElevatorFormFields>({
    initialValues: {
      title: '',
      address: null,
      company: null,
      grain_elevator_railway_station: null,
      capacity: null,
      provided_services: '',
      acceptance_costs: null,
      storage_costs: null,
      storage_costs_unit: 'per_day',
      mechanical_railcar_loading_costs: null,
      rail_car_capacity: null,
      expedite_costs: null,
      documents_costs: null,
      other_costs: null,
      composite_costs: null,
      is_composite_costs: false,
      comment: '',
    },

    onSubmit: formHandler(
      (value) => {
        const {
          title,
          address,
          company,
          grain_elevator_railway_station,
          capacity,
          provided_services,
          rail_car_capacity,
          ...rest
        } = value
        const dto = {
          title,
          address,
          company,
          grain_elevator_railway_station,
          capacity,
          provided_services,
          rail_car_capacity,
          elevator_costs: rest,
        }
        return apiClient.post(endpoints.elevators(), dto)
      },
      {
        onSuccess: () => {
          onSuccess()
          onClose()
        },

        onError: (err) => {
          const { errors } = err as RequestError
          formik.setErrors(removePropertyNamePrefix(errors, /elevator_costs./))
        },
      },
    ),
  })

  return (
    <ResponsiveModal
      id="addElevatorModal"
      onClose={onClose}
      title={t('addElevator')}
      onConfirm={formik.submitForm}
      progress={formProgress}
    >
      <ElevatorCommonFields formik={formik} />
    </ResponsiveModal>
  )
}
